import { storeToRefs } from "pinia";
import { defineComponent, computed, onMounted, ref, nextTick, } from "vue";
import { useMaintenanceScheduleStore } from "./maintenanceScheduleStore";
import { MaintenanceScheduleType } from "./maintenanceScheduleEnums";
import { maintenanceScheduledescription } from "./maintenanceScheduleData";
export default defineComponent({
    name: "MaintenanceScheduleResults",
    setup() {
        // data - non-reactive
        const selectedScheduleAttribute = "aria-selected";
        const defaultMileageClass = "default-mileage";
        let serviceScheduleNameElements;
        const store = useMaintenanceScheduleStore();
        const description = maintenanceScheduledescription;
        // data - reactive
        const { maintenanceScheduleNormal, maintenanceScheduleSevere, selectedVehicle, } = storeToRefs(store);
        let selectedScheduleIndex = ref(0);
        let maintenanceScheduleType = ref(MaintenanceScheduleType.Normal);
        let normalButtonElement;
        let severeButtonElement;
        // computed
        const maintenanceSchedule = computed(() => maintenanceScheduleType.value === MaintenanceScheduleType.Normal
            ? maintenanceScheduleNormal.value
            : maintenanceScheduleSevere.value);
        const resultsTitle = computed(() => maintenanceScheduleType.value === MaintenanceScheduleType.Normal
            ? "Normal Maintenance Schedule"
            : "Severe Maintenance Schedule");
        const selectedMaintenanceScheduleType = computed(() => maintenanceScheduleType.value);
        const selectedVehicleDetails = computed(() => {
            return {
                photoUrl: selectedVehicle.value.photoUrl,
                year: selectedVehicle.value.year,
                model: selectedVehicle.value.model,
                trim: selectedVehicle.value.trim,
                mileage: parseInt(selectedVehicle.value.mileage).toLocaleString(),
            };
        });
        selectedScheduleIndex.value =
            maintenanceSchedule.value !== undefined
                ? maintenanceSchedule.value.MaintenanceSchedule.intervals.findIndex((interval) => interval.closestMileage === true)
                : 0;
        const resultsServiceDetails = computed(() => {
            const maintenanceScheduleIntervals = maintenanceSchedule.value.MaintenanceSchedule.intervals;
            const maintenanceScheduleHasData = maintenanceScheduleIntervals.length > 0 &&
                selectedScheduleIndex.value <=
                    maintenanceScheduleIntervals.length - 1 &&
                maintenanceScheduleIntervals[selectedScheduleIndex.value] !==
                    undefined;
            return maintenanceScheduleHasData
                ? maintenanceScheduleIntervals[selectedScheduleIndex.value].items
                : [];
        });
        const resultsServiceScheduleNames = computed(() => {
            return Array.from(maintenanceSchedule.value.MaintenanceSchedule.intervals, (interval) => {
                return { name: interval.name, mileage: interval.mileage };
            });
        });
        // methods - used in DOM
        function getSelectedSchedule(event, scheduleListIndex) {
            selectedScheduleIndex.value = scheduleListIndex;
            updateSelectedScheduleStyling(event.currentTarget);
        }
        function getMaintenanceSchedule() {
            maintenanceScheduleType.value =
                maintenanceScheduleType.value === MaintenanceScheduleType.Normal
                    ? MaintenanceScheduleType.Severe
                    : MaintenanceScheduleType.Normal;
            initializeMaintenanceSchedule();
        }
        function chooseNewVehicle() {
            store.getNewVehicle();
            window.scroll(0, 0);
        }
        function focusDetails() {
            const firstDetailItem = document.querySelectorAll("#serviceDetails .detail");
            firstDetailItem[0].focus();
        }
        // methods - NOT used in DOM
        onMounted(() => {
            initializeMaintenanceSchedule();
            scrollMaintenanceScheduleSectionIntoView();
        });
        function initializeMaintenanceSchedule() {
            nextTick(() => {
                selectedScheduleIndex.value =
                    maintenanceSchedule.value.MaintenanceSchedule.intervals.findIndex((internval) => internval.closestMileage);
                const preferredMileage = maintenanceSchedule.value.MaintenanceSchedule.intervals.find((internval) => internval.closestMileage)?.mileage;
                const serviceScheduleNameElementList = document.querySelectorAll(".service-schedule-name");
                if (serviceScheduleNameElementList.length > 0) {
                    serviceScheduleNameElements = Array.from(serviceScheduleNameElementList, (element) => element);
                    const preferredScheduleElement = serviceScheduleNameElements.find((element) => element.dataset.mileage === preferredMileage.toString());
                    stylePreferredScheduleName(preferredScheduleElement);
                    scrollSelectedScheduleIntoView(preferredScheduleElement);
                }
            });
        }
        function stylePreferredScheduleName(preferredScheduleElement) {
            let previousPreferredMileageIconElement;
            serviceScheduleNameElements.find((nameElement) => {
                const iconElement = nameElement.querySelector("i");
                if (iconElement?.classList.contains(defaultMileageClass)) {
                    previousPreferredMileageIconElement = iconElement;
                }
            });
            previousPreferredMileageIconElement?.classList.remove(defaultMileageClass);
            const preferredMileageIconElement = preferredScheduleElement.querySelector("i");
            preferredMileageIconElement.classList.add(defaultMileageClass);
            removeStylingFromPreviousScheduleElement();
            preferredScheduleElement.setAttribute(selectedScheduleAttribute, "true");
        }
        function removeStylingFromPreviousScheduleElement() {
            serviceScheduleNameElements.find((scheduleNameElement) => {
                if (scheduleNameElement.getAttribute(selectedScheduleAttribute)) {
                    scheduleNameElement.removeAttribute(selectedScheduleAttribute);
                }
            });
        }
        function scrollMaintenanceScheduleSectionIntoView() {
            const maintenanceScheduleSection = document.querySelector(".subaru-maintenance-schedule__form-results");
            window.scrollTo({
                top: maintenanceScheduleSection.offsetTop - 120,
                behavior: "smooth",
            });
        }
        function scrollSelectedScheduleIntoView(selectedScheduleElement) {
            const selectedScheduleElementParentElement = document.querySelector(".service-schedule-list__service-schedule-names");
            const selectedScheduleElementOffsetTop = selectedScheduleElement.offsetTop;
            const parentElementHeight = selectedScheduleElementParentElement.clientHeight;
            selectedScheduleElementParentElement.scrollTop =
                selectedScheduleElementOffsetTop - parentElementHeight / 2.2;
        }
        function updateSelectedScheduleStyling(newSchedule) {
            const oldSchedule = serviceScheduleNameElements.find((element) => element.getAttribute(selectedScheduleAttribute) !== null);
            oldSchedule.removeAttribute(selectedScheduleAttribute);
            newSchedule.setAttribute(selectedScheduleAttribute, "true");
        }
        return {
            resultsTitle,
            resultsServiceDetails,
            resultsServiceScheduleNames,
            description,
            selectedVehicleDetails,
            normalButtonElement,
            severeButtonElement,
            selectedMaintenanceScheduleType,
            getSelectedSchedule,
            getMaintenanceSchedule,
            chooseNewVehicle,
            focusDetails,
        };
    },
});
